import { getDynamicOptions } from './get-dynamic-options';
import { applyFieldLogic } from './apply-field-logic';
import { cleanFormData } from './clean-form-data';
import { shouldShowField } from './should-show-field';

export const getRugbyUrbaMiniHelpers = () => ({
  getDynamicOptions,
  applyFieldLogic,
  cleanFormData,
  shouldShowField
});
